import { createTheme } from '@mui/material/styles';

// Create custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#31C48D', // Main color (Green)
    },
    secondary: {
      main: '#4CAF50', // Secondary color (Blue)
    },
    error: {
      main: '#D32F2F', // Error color (Red)
    },
    success: {
      main: '#4CAF50', // Success color (Green)
    },
    text: {
      primary: '#000000', // Black text
      secondary: '#686978', // Grey text
    },
    orange:"#FF9417"
  },
  typography: {
    fontFamily: [
      '-apple-system', // Apple's font (SF Pro)
      'BlinkMacSystemFont', // For Safari fallback
      'Segoe UI', // Windows fallback
      
    ].join(','), // Custom font
    h5: {
      fontWeight: 700,
    },
    body1: {
      fontSize: '16px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Disable uppercase text
          borderRadius: '8px', // Rounded buttons
          transition: '0.3s', // Smooth transition
          '&:hover': {
            transform: 'scale(1.05)', // Button hover effect
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px', // Rounded cards
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', // Shadow for app bar
        },
      },
    },
  },
});

export default theme;